<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="structure">
<div class="epigraph">
<div class="senseline">
<p class="epsl"><a class="page" id="pv"></a>what’s your name</p>
<p class="epsl">what’s your sign</p>
<p class="epsl">what’s your disease</p>
<p class="epslf">i saw you standing there</p>
<p class="epsl">pretty as you please</p>
<p class="epsl">and couldn’t help wondering</p>
<p class="epsl">which of these</p>
<p class="epsl">afflicts you:</p>
<p class="epslf">sores around the mouth</p>
<p class="epsl">or further south</p>
<p class="epsl">swelling of the joints</p>
<p class="epsl">or other points</p>
<p class="epsl">lesions or lumps</p>
<p class="epsl">blisters or bumps</p>
<p class="epsl">or feeling generally queasy</p>
<p class="epsl">from being too easy</p>
<p class="epslf">seems everyone has something</p>
<p class="epsl">and is avoiding something more</p>
<p class="epsl">from the saints among us</p>
<p class="epsl">to those who are hor-</p>
<p class="epsl">monally imbalanced</p>
<p class="epsl">and can’t get enough</p>
<p class="epsl">of that funky stuff</p>
<p class="epslf">i’m not casting aspersions</p>
<p class="epsl">or condemning diversions</p>
<p class="epsl">just a prudent inspection</p>
<p class="epsl">to compare your infection</p>
<p class="epsl">with mine</p>
<p class="epslf">i’m in no position</p>
<p class="epsl">to judge your condition</p>
<p class="epsl">or condemn you</p>
<p class="epsl">and call you a sleaze</p>
<p class="epslf">but before we’re encased</p>
<p class="epsl">in something debased</p>
<p class="epsl">please tell me</p>
<p class="epsl">what’s your disease</p>
</div>
<p class="ept">Bill Russell, “Epitaph for the Sexual Revolution,” <i>Christopher Street</i>, December 1982</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mckay-0005.vue?b3d7b5ae